import gql from 'graphql-tag';
export default gql`
  query subDivisions($param: String!) {
    subDivisions(param: $param) {
      docId
      name
    }
  }
`;
